
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { PermissionsView } from "../Permissions/View.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ReceiverSettings } from "../Receivers/View.js";
import { InventoryNumberSettings } from "./Inventory/View.js";
import { ProtocolSettings } from "./Protocol/View.js";
import { AppLogoSettings } from "./Logo/View.js";
import { UnitsSettings } from "./Units/View.js";
import { SSOSettings } from "./SSO/View.js";

export function SystemSettingsView(props) {
    let elems_9, elems, elems_8;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("permissions-section");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]"])], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "permissions-section",
            Label: t("settings.permissions"),
        }), delay(() => append(singleton({
            Id: "receivers-section",
            Label: t("settings.receivers"),
        }), delay(() => append(singleton({
            Id: "inventory-section",
            Label: t("settings.inventory.title"),
        }), delay(() => append(singleton({
            Id: "protocol-section",
            Label: t("settings.protocol.title"),
        }), delay(() => append(singleton({
            Id: "logo-section",
            Label: t("settings.logo.title"),
        }), delay(() => append(singleton({
            Id: "units-section",
            Label: t("settings.units.title"),
        }), delay(() => {
            const matchValue_1 = props.UserData.Role;
            let matchResult;
            if (props.AccountSettings.SsoEnabled) {
                switch (matchValue_1) {
                    case "toolManager":
                    case "user": {
                        matchResult = 1;
                        break;
                    }
                    default:
                        matchResult = 0;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton({
                        Id: "sso-section",
                        Label: t("settings.sso.sso"),
                    });
                default: {
                    return empty();
                }
            }
        })))))))))))))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_8 = toList(delay(() => {
        let elems_1, Title;
        return append(singleton(reactElement("section", createObj(ofArray([["id", "permissions-section"], (elems_1 = [createElement(SectionContainer, (Title = t("settings.permissions"), {
            Content: createElement(PermissionsView, {
                AccountSettings: props.AccountSettings,
            }),
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "receivers-section"], (elems_2 = [createElement(SectionContainer, (Title_1 = t("settings.receivers"), {
                Content: createElement(ReceiverSettings, null),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3, Title_2;
                return append(singleton(reactElement("section", createObj(ofArray([["id", "inventory-section"], (elems_3 = [createElement(SectionContainer, (Title_2 = t("settings.inventory.title"), {
                    Content: createElement(InventoryNumberSettings, {
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                    let elems_4, Title_3;
                    return append(singleton(reactElement("section", createObj(ofArray([["id", "protocol-section"], (elems_4 = [createElement(SectionContainer, (Title_3 = t("settings.protocol.title"), {
                        Content: createElement(ProtocolSettings, {
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                        let elems_5, Title_4;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "logo-section"], (elems_5 = [createElement(SectionContainer, (Title_4 = t("settings.logo.title"), {
                            Content: createElement(AppLogoSettings, {
                                OnConfigurationChanged: props.OnConfigurationChanged,
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                            let elems_6, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "units-section"], (elems_6 = [createElement(SectionContainer, (Title_5 = t("settings.units.title"), {
                                Content: createElement(UnitsSettings, null),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                                let elems_7, Title_6;
                                const matchValue_4 = props.UserData.Role;
                                let matchResult_1;
                                if (props.AccountSettings.SsoEnabled) {
                                    switch (matchValue_4) {
                                        case "toolManager":
                                        case "user": {
                                            matchResult_1 = 1;
                                            break;
                                        }
                                        default:
                                            matchResult_1 = 0;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                                switch (matchResult_1) {
                                    case 0:
                                        return singleton(reactElement("section", createObj(ofArray([["id", "sso-section"], (elems_7 = [createElement(SectionContainer, (Title_6 = t("settings.sso.sso"), {
                                            Content: createElement(SSOSettings, {
                                                UserData: props.UserData,
                                            }),
                                            Title: unwrap(Title_6),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                                    default: {
                                        return empty();
                                    }
                                }
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))]))))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
}

